import React, { useContext, useEffect, useState } from "react";
import PedidosYaStyle from "../../../../assets/css/components/admin/plugins/PedidosYaStyle";
import { Select } from "../../../../assets/css/components/admin/products/ShowProductInfo/ShowProductInfo.css";
import handleAxiosError from "../../update-and-publish/functions/handleAxiosError";
import axios from "axios";
import {
  keyAccessToken,
  keyUserId,
} from "../../../../assets/js/SessionStorageNames";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import VtexCredentials from "./vtexCredentials";
import { downloadCategoriesVtex, syncProductsVtex, updateProductsVtex } from "../../../../hooks/api/vtex";

export default function View({ username, step = 2, listUsers }) {
  const [loading, setLoading] = useState(false);
  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [tarifas, setTarifas] = useState([]);
  const [tarifaSelected, setTarifaSelected] = useState(null);
  const globalContext = useContext(GlobalContext);
  const [skuId, setSkuId] = useState(null);

  const changeTarifa = (t) => {
    setTarifaSelected(t);
    console.log(t);
  };


  const donwloadCategories = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      console.log('username')
      console.log(entId)
      console.log(username)
      console.log('username')
      const resp = await downloadCategoriesVtex(entId, username)
      console.log('se ejecuto', resp)
      if(resp?.data?.message) await globalContext.showModalWithMsg('Se ha iniciado la descarga de categorias en segundo plano.');
    } catch (error) {
      console.log(error);
      await globalContext.showModalWithMsg('Ha ocurrido un error al descargar las productos.');
    }
}

  const syncProducts = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      const resp = await syncProductsVtex(entId, username)
      if(resp?.message) await globalContext.showModalWithMsg('Se ha iniciado el proceso de sincronización de productos en segundo plano.');
    } catch (error) {
      console.log(error);
      await globalContext.showModalWithMsg('Ha ocurrido un error al sincronizar los productos.');
    }
  }
  const updateProducts = async () => {
    try {
      const entId = globalContext.currentEnterpriseId;
      console.log(skuId, 'sku')
      const resp = await updateProductsVtex(entId, username, skuId)
      if(resp?.message) await globalContext.showModalWithMsg('Se ha iniciado el proceso de sincronización de productos en segundo plano.');
    } catch (error) {
      console.log(error);
      await globalContext.showModalWithMsg('Ha ocurrido un error al sincronizar los productos.');
    }
  }
  /**
   * Function to consult the lists of available rates
   */
  async function getPriceList() {
    const entId = await globalContext.currentEnterpriseId;
    const url = `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-pricelist/${entId}`;
    if (entId)
      await axios
        .get(url, {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        })
        .then((resp) => {
          const data = resp.data.data;
          setTarifas(data.priceLists);
          console.log(data.priceLists);
        })
        .catch((err) => {
          console.log(err);
          handleAxiosError(
            err,
            "Disculpe, no se pudo cargar la lista de tarifas."
          );
        });
  }

  useEffect(() => {
    getPriceList();
  }, [globalContext.currentEnterpriseId]);

  const ui = {
    opsWrap: {
      marginTop: 36,
      borderRadius: 18,
      border: "1px solid #f0d7e2",
      overflow: "hidden",
      background: "#ffffff",
      boxShadow: "0 14px 34px rgba(20, 32, 50, 0.08)",
    },
    opsHeader: {
      background: "#1465BB",
      padding: "16px 22px",
      borderBottom: "1px solid #f6b4ca",
    },
    opsHeaderTitle: {
      color: "#ffffff",
      fontWeight: 700,
      letterSpacing: "0.02em",
      margin: 0,
      fontSize: "18px",
      fontFamily: "sans-serif",
    },
    opsHeaderSub: {
      color: "rgba(255,255,255,0.9)",
      margin: "7px 0 0",
      fontSize: 14,
      fontFamily: "sans-serif",
    },
    opsBody: {
      padding: "24px 22px 28px",
      background: "linear-gradient(180deg, #fff8fb 0%, #ffffff 100%)",
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: 16,
    },
    actionCard: {
      border: "1px solid #f1dbe5",
      borderRadius: 14,
      background: "#ffffff",
      padding: "25px 16px",
      boxShadow: "0 8px 18px rgba(247, 25, 99, 0.08)",
      display: "flex",
      flexDirection: "column",
      gap: 12,
      fontFamily: "sans-serif",
    },
    actionTitle: {
      margin: 0,
      color: "#142032",
      fontWeight: 700,
      fontSize: "14px",
    },
    actionDesc: {
      margin: 0,
      color: "#5d677c",
      fontSize: 14,
      lineHeight: 1.45,
      padding: "0.5rem 1.1rem",
      textAlign: "justify",
    },
    actionBtn: {
      width: "100%",
      borderRadius: 10,
      minHeight: 50,
      border: "none",
      background: "#1465BB",
      color: "#ffffff",
      fontWeight: 600,
      boxShadow: "0 10px 20px rgba(217, 250, 99, 0.45)",
      fontFamily: "sans-serif",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
    },
  };

  return (
    <>
      {step === 2 ? (
        <>
          <PedidosYaStyle.ContForm style={ui.opsWrap}>
            <PedidosYaStyle.HeaderForm style={ui.opsHeader}>
              <h3 style={ui.opsHeaderTitle}>Operaciones VTEX - {username}</h3>
              <p style={ui.opsHeaderSub}>
                Ahora puedes sincronizar productos y descargar categorias.
              </p>
            </PedidosYaStyle.HeaderForm>

            <PedidosYaStyle.BodyForm style={ui.opsBody}>
              <div style={ui.actionCard}>
                <h4 style={ui.actionTitle}>Sincronizar productos</h4>
                <p style={ui.actionDesc}>
                  Inicia la sincronizacion completa de VTEX en segundo plano y tambien actualiza productos.
                </p>
                <PedidosYaStyle.BtnSend onClick={syncProducts} style={ui.actionBtn}>
                  {loading ? "Espere" : "Sincronizar todos los productos"}
                </PedidosYaStyle.BtnSend>
              </div>

              <div style={ui.actionCard}>
                <h4 style={ui.actionTitle}>Descargar categorias</h4>
                <p style={ui.actionDesc}>
                  Actualiza las categorias disponibles para mantener consistente el catalogo.
                </p>
                <PedidosYaStyle.BtnSend onClick={donwloadCategories} style={ui.actionBtn}>
                  {loading ? "Espere" : "Descargar categorias"}
                </PedidosYaStyle.BtnSend>
              </div>
            </PedidosYaStyle.BodyForm>
          </PedidosYaStyle.ContForm>
        </>
      ) : (
        <>
          <VtexCredentials username={username} loading={loading} setLoading={setLoading} listUsers={listUsers} />
        </>
      )}
    </>
  );
}
